import React, { createContext, useState, useContext } from 'react';

const StatusContext = createContext();

export const useStatus = () => useContext(StatusContext);

export const StatusProvider = ({ children }) => {
  const [status, setStatus] = useState('DASHBOARD'); // Default status: DASHBOARD, PENDING, APPROVED

  const value = {
    status,
    setStatus,
  };

  return (
    <StatusContext.Provider value={value}>
      {children}
    </StatusContext.Provider>
  );
};
